import { Right, SofaV2 } from "@repo/icons";
import { Link } from "@tanstack/react-router";
import { graphql } from "@repo/graphql-types";
import { useState } from "react";
import { formatWithZonedDate } from "@repo/lib";
import {
  SectionHeaderButton,
  SectionHeaderContent,
  SectionHeaderIcon,
  SectionHeaderInfo,
  SectionHeaderRoot,
  SectionHeaderTitle,
} from "@/components/section-header";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/async-data-wrapper";
import { HomeNextSchedulesCarousel } from "@/components/home/home-next-schedules-carousel";
import { ErrorCard } from "@/components/home/error-card.tsx";
import { Skeleton } from "@/components/skeleton.tsx";

export const HomeNextSchedulesSectionQuery = graphql(/* GraphQL */ `
  query HomeNextSchedulesSectionQuery($today: date) {
    ...HomeNextSchedulesCarouselQueryFragment
  }
`);

const INITIAL_REFETCH_INTERVAL = 2_000;
const DEFAULT_REFETCH_INTERVAL = 30_000;

export const HomeNextSchedulesSection = (): JSX.Element => {
  const [refetchInterval, setRefetchInterval] = useState(INITIAL_REFETCH_INTERVAL);
  const today = formatWithZonedDate(new Date());

  const queryResult = useGraphQL(
    HomeNextSchedulesSectionQuery,
    {
      today,
    },
    { refetchInterval },
  );

  const { data, isRefetching, refetch } = queryResult;

  if (isRefetching && refetchInterval === INITIAL_REFETCH_INTERVAL) {
    setRefetchInterval(DEFAULT_REFETCH_INTERVAL);
  }

  const fallback = <Skeleton className="mx-4 rounded-lg h-[9.2rem]" />;
  const refetchNextSchedulesQuery = (): void => {
    void refetch();
  };

  return (
    <div className="flex flex-col gap-4">
      <SectionHeaderRoot className="px-4">
        <SectionHeaderContent>
          <SectionHeaderIcon className="bg-white">
            <SofaV2 size={16} className="fill-primary-400" />
          </SectionHeaderIcon>
          <SectionHeaderInfo>
            <SectionHeaderTitle>Próx. atendimentos</SectionHeaderTitle>
          </SectionHeaderInfo>
        </SectionHeaderContent>
        <Link to="/waiting-room">
          <SectionHeaderButton>
            Sala espera <Right size={16} />
          </SectionHeaderButton>
        </Link>
      </SectionHeaderRoot>
      <AsyncDataWrapper
        {...queryResult}
        errorFallback={<ErrorCard onClick={refetchNextSchedulesQuery} />}
        fallback={fallback}
      >
        {data ? <HomeNextSchedulesCarousel data={data} /> : null}
      </AsyncDataWrapper>
    </div>
  );
};
